import { DataProcessingAgreement } from '../../domain/DataProcessingAgreement';
import DataProcessingAgreementDto from './DataProcessingAgreementDto';

export function fromStorageResponse(
  blobArray: DataProcessingAgreementDto[]
): DataProcessingAgreement[] {
  if (!blobArray || blobArray.length === 0) return [];
  return blobArray.map((data) => dtoToDataProcessingAgreement(data));
}

export function dtoToDataProcessingAgreement(agreementDto: DataProcessingAgreementDto) {
  return {
    version: agreementDto.Metadata.version || 'unknown',
    url: agreementDto.Url
  } as DataProcessingAgreement;
}
